import { useTranslation } from 'hooks/useTranslation'
import { InformationCollapse, InformationCollapseType } from 'components/InformationCollapse'
import { Text } from 'components/Text'
import Trans from 'next-translate/Trans'
import { nutritionFormatter } from 'features/Recipes/utils/nutritionFormatter'
import { NUTRITION_FREEZE_DRIED } from 'fixtures/nutrition'
import { FreezeDriedProteins } from 'models/Pet'
import { ProductDetailsRoot, ProductDetailsContainer } from './ProductDetails.styles'
import { FeedingGuidelinesTable } from '../../../FreezeDriedBox/components/FeedingGuidelinesTable/FeedingGuidelinesTable'

export const ProductDetails = () => {
  const { t } = useTranslation()

  const beefNutrition = nutritionFormatter(NUTRITION_FREEZE_DRIED[FreezeDriedProteins.BEEF])
  const chickenNutrition = nutritionFormatter(NUTRITION_FREEZE_DRIED[FreezeDriedProteins.CHICKEN])

  const IngredientsContent = () => (
    <>
      <Text weight="semiBold" css={{ display: 'block', marginBottom: '$1' }}>
        {t('recipes:freeze-dried.CHICKEN.hero.header')}
      </Text>
      <Text css={{ display: 'block', marginBottom: '$3' }}>
        {NUTRITION_FREEZE_DRIED[FreezeDriedProteins.CHICKEN].ingredients}
      </Text>
      <Text weight="semiBold" css={{ display: 'block', marginBottom: '$1' }}>
        {t('recipes:freeze-dried.BEEF.hero.header')}
      </Text>
      <Text css={{ display: 'block' }}>
        {NUTRITION_FREEZE_DRIED[FreezeDriedProteins.BEEF].ingredients}
      </Text>
    </>
  )

  const NutritionContent = () => (
    <>
      <Text weight="semiBold" css={{ display: 'block', marginBottom: '$1' }}>
        {t('recipes:freeze-dried.CHICKEN.hero.header')}
      </Text>
      <Trans
        i18nKey="recipes:freeze-dried.nutrition-description"
        components={{ br: <br />, strong: <strong /> }}
        values={chickenNutrition}
      />
      <Text weight="semiBold" css={{ display: 'block', marginTop: '$3', marginBottom: '$1' }}>
        {t('recipes:freeze-dried.BEEF.hero.header')}
      </Text>
      <Trans
        i18nKey="recipes:freeze-dried.nutrition-description"
        components={{ br: <br />, strong: <strong /> }}
        values={beefNutrition}
      />
    </>
  )

  const infoList: InformationCollapseType[] = [
    {
      label: 'recipes:hero-v2.ingredients',
      description: '' as any,
      extraContent: <IngredientsContent />,
    },
    {
      label: 'recipes:hero-v2.nutritional-information',
      description: '' as any,
      extraContent: <NutritionContent />,
    },
    {
      label: 'products-v2:freeze-dried-box.hero.feeding-guidelines.label',
      description: 'products-v2:freeze-dried-raw-nuggets.product-details.feeding-guidelines.description',
      extraContent: <FeedingGuidelinesTable />,
    },
    {
      label: 'recipes:hero-v2.safety',
      description: 'products-v2:freeze-dried-raw-nuggets.product-details.safety',
    },
  ]

  return (
    <ProductDetailsRoot>
      <ProductDetailsContainer>
        <InformationCollapse v2 infoList={infoList} />
      </ProductDetailsContainer>
    </ProductDetailsRoot>
  )
}

ProductDetails.displayName = 'ProductDetails'
